import { COLOR } from '@george-labs.com/design-system';

export const creditCardContentBox = {
    showLockAndUnlockNavigation: false,
    showDisplayPinNavigation: false,
    showBalanceIncreaseNavigation: false,
    showPayUpNavigation: false,
    cardMeter: {
        addAuthorizedAmountToValue: false,
        limitReachedColor: COLOR.UI_GREEN,
    },
    cardLegend: {
        defaultColor: COLOR.UI_GREEN,
        invertAuthorizedAmount: false,
        invertOutstandingAmount: false,
        showBalanceAsOutstandingAmount: false,
    },
};
